// extracted by mini-css-extract-plugin
export default {"link":"_s0yxY","message":"C4zMUK","list":"_1uhb8","text":"ACLg_r","item":"Vnk6Zw"};